﻿import type { ICoordinateSpace } from "../../app/viewer/rendering/CoordinateSpace";
import type { IPoint } from "../../app/viewer/rendering/Point";

export const sortTopThenLeft = <TCoordinateSpace extends ICoordinateSpace<TCoordinateSpace>>(a: IPoint<TCoordinateSpace>, b: IPoint<TCoordinateSpace>) => {
	if (a.y < b.y) return -1;
	else if (a.y > b.y) return 1;
	else if (a.x < b.x) return -1;
	else if (a.x > b.x) return 1;

	return 0;
};

export const sortBottomThenRight = <TCoordinateSpace extends ICoordinateSpace<TCoordinateSpace>>(a: IPoint<TCoordinateSpace>, b: IPoint<TCoordinateSpace>) => {
	if (a.y > b.y) return -1;
	else if (a.y < b.y) return 1;
	else if (a.x > b.x) return -1;
	else if (a.x < b.x) return 1;

	return 0;
};
